import api from './'

export default {
    /**
     * Assign an agent
     * @param agentId
     * @param data
     */
    assign(agentId, data) {
        return api
            .post(`agents/${agentId}/assign`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Unassign any agent from model
     * @param data
     */
    unassign(data) {
        return api
            .post(`agents/unassign`, data)
            .then(response => {
                return response.data
            })
    },
}
